
$(function(){

    let pcQ = window.matchMedia( "(min-width: 768px)");
    let spQ = window.matchMedia( "(max-width: 767px)");

    let Modal = function(){};
    Modal.prototype ={
        createOverlay : function(){
            $("body").append('<div id="modal-overlay"></div>');
        },
        modalFadeIn : function(){
            $("#modal-overlay").fadeIn("slow");
            $("#modal-content").fadeIn("slow");
            $("body").addClass("hide");
        },
        modalFadeOut : function(){
            $("#modal-overlay").fadeOut("slow");
            $("#modal-content").fadeOut("slow");
            $("body").removeClass("hide");
        },
    };

    //プレイヤー変数
    var player;
    //Youtubeオブジェクト生成
    var YTflag = true;
    function youtubeAPIInit(youtube) {
        if(YTflag){
            var scriptTag = document.createElement('script');
            scriptTag.src = "https://www.youtube.com/iframe_api";
            var fsTag = document.getElementsByTagName('script')[0];
            fsTag.parentNode.insertBefore(scriptTag, fsTag);
        }
        window.onYouTubeIframeAPIReady = function(){
            player = new YT.Player('player', {
                height:'540',
                width:'960',
                videoId: youtube,
                playerVars:{
                    modestbranding:1,
                    showinfo:0,
                    rel:0,
                    autoplay:0
                }
            });
        };
        YTflag = false;
    }

    let YTmodal = new Modal();

    //モーダルオープン
    $('#ytmodal-open').on('click',function (){
        YTmodal.createOverlay();
        $("#modal-overlay").addClass("close_youtube");
        YTmodal.modalFadeIn();
        player.playVideo();
    });

    //モーダルクローズ
    $(document).on('click',".close_youtube",function (){
        player.stopVideo();
        YTmodal.modalFadeOut();
    });


    //SP用

    pcQ.addListener(pcYoutubeQuery);
    spQ.addListener(spYoutubeQuery);

    function pcYoutubeQuery(pcQ){
        if(pcQ.matches === true){
            player.stopVideo();
        }
    };

    function spYoutubeQuery(spQ){
        if(spQ.matches === true){
            youtubeAPIInit("89ACvues-50");
            $("#modal-content").removeAttr("style");
            player.stopVideo();
            $("#modal-overlay").removeAttr("style");
            $("body").removeClass("hide");
        }
    };

    //ロード時にyoutube生成
    youtubeAPIInit("89ACvues-50");
});
